import { ALL_DEPS_TOKEN } from 'src/app/tenant-selector/state/tenant-user-access.state';

export function filterAllDepsToken(departmentIds?: string[]): string[] {
  return (departmentIds || []).filter(
    (departmentId) => !!departmentId && departmentId !== ALL_DEPS_TOKEN
  );
}
